import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import { FunctionDto, CompanyDto } from '@cradua/data';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-companyfunction',
  templateUrl: './companyfunction.component.html',
  styleUrls: ['./companyfunction.component.scss'],
})
export class CompanyFunctionComponent implements OnChanges {
  @Input() companyfunctions: FunctionDto[];
  @Input() companies: CompanyDto[];
  companyfunctionForm: FormGroup;
  companyfunctionFormArray: FormGroup;
  control = new FormControl();
  @Input() routeAnimationsElements: any;
  @Output() changeEmit = new EventEmitter<FunctionDto>();
  @Output() deleteEvent = new EventEmitter<any>();

  filteredDelete: Array<any> = [];
  filteredCompanyFunction: Array<any> = [];
  status: boolean;
  selectedCompanyFunctionId: any;
  selectedIndex = null;

  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    this.createCompanyFunctionForm();
    console.log('onChanges', this.companyfunctions);
  }

  createCompanyFunctionForm() {
    this.companyfunctionFormArray = this.fb.group({
      CompanyFunctions: this.fb.array([]),
    });
    this.companyfunctionForm = this.fb.group({
      FunctionName: ['', Validators.required],
      CompanyId: this.selectedCompanyFunctionId,
      id: null,
    });
  }

  // method to display companies
  setCompanyFunction() {
    const control = this.companyfunctionFormArray.controls
      .CompanyFunctions as FormArray;
    this.filteredCompanyFunction.forEach((e) => {
      console.log('foreach value ', e);
      control.push(
        this.fb.group({
          FunctionName: e.FunctionName,
          CompanyId: e.CompanyId,
          id: e.id,
        })
      );
    });
  }

  // method to add Company
  addCompanyFunction(companyfunction: FunctionDto) {
    console.log('companyfunction');
    const control = this.companyfunctionFormArray.controls
      .CompanyFunctions as FormArray;
    control.insert(
      0,
      this.fb.group({
        FunctionName: companyfunction.FunctionName,
        CompanyId: this.selectedCompanyFunctionId,
      })
    );
  }

  // method to reset form array after selection
  clearFormArray = (formArray: FormArray) => {
    const control = this.companyfunctionFormArray.controls
      .CompanyFunctions as FormArray;
    while (formArray.length !== 0) {
      control.removeAt(0);
    }
  };

  // method to filter companyfunction
  selectCompany(event: string) {
    this.filteredCompanyFunction = this.companyfunctions.filter(
      (s) => s.CompanyId === event
    );
    this.selectedCompanyFunctionId = event;
    const control = this.companyfunctionFormArray.controls
      .CompanyFunctions as FormArray;

    if (this.filteredCompanyFunction.length > 0) {
      this.status = true;
      this.clearFormArray(control);
      this.setCompanyFunction();
    } else {
      this.status = true;
      this.clearFormArray(control);
    }
  }

  print(event: any) {
    window.print();
  }
  // method to delete company from arrary list
  deleteCompanyFunction(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.companyfunctionFormArray.controls
          .CompanyFunctions as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.companyfunctions.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.companyfunctions[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  addNew(formValue: FunctionDto) {
    if (this.companyfunctionForm.invalid) {
      return Swal.fire(
        'Warning!',
        'Please, you cannot add blank field',
        'warning'
      );
    }
    if (this.selectedIndex != null) {
      this.companyfunctionFormArray
        .get('CompanyFunctions')
        ['controls'][this.selectedIndex].patchValue({
          FunctionName: formValue.FunctionName,
        });
    } else {
      this.addCompanyFunction(formValue);
    }
    this.selectedIndex = null;
    this.companyfunctionForm.reset();
  }

  onEdit(index, value: FunctionDto) {
    this.selectedIndex = index;
    this.companyfunctionForm.patchValue({ FunctionName: value.FunctionName });
  }

  onClearForm() {
    this.selectedIndex = null;
    this.companyfunctionForm.reset();
  }

  onSubmit(formValue: any) {
    formValue.type = 'companyfunction';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length > 0) {
      this.filteredDelete.unshift('companyfunction');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }
}
